import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Avatar,
  Container,
  Button,
  Divider,
} from '@mui/material';
import { motion } from 'framer-motion';
import { Lightbulb, Public, Group, ContactMail } from '@mui/icons-material';

// اضافه کردن ایمپورت useNavigate
import { useNavigate } from 'react-router-dom';

const teamMembers = [
  { name: 'Marwa Habibi', role: 'Back-End Development', avatar: 'M' },
  { name: 'Marjan Habibi', role: 'Front-End Development', avatar: 'M' },
];

export default function About() {
  // مقداردهی navigate
  const navigate = useNavigate();

  return (
    <Box sx={{ bgcolor: '#f4f7fa', minHeight: '100vh', pb: 12 }}>
      {/* Hero */}
      <Box
        sx={{
          background:
            'linear-gradient(135deg, #4a90e2cc 30%, #9013fecc 90%)',
          color: 'white',
          py: { xs: 10, md: 16 },
          textAlign: 'center',
          px: 3,
          position: 'relative',
          overflow: 'hidden',
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <Typography variant="h2" fontWeight="700" gutterBottom sx={{ color: 'white' }}>
  STI EDU 
</Typography>
          <Typography
            variant="h6"
            sx={{ maxWidth: 600, mx: 'auto', fontWeight: 500 }}
          >
            Empowering learners worldwide with passion and innovation.
          </Typography>
          <Button
            variant="contained"
            sx={{
              mt: 5,
              px: 5,
              py: 1.5,
              borderRadius: 3,
              fontWeight: 600,
              backgroundColor: '#fff',
              color: '#4a90e2',
              '&:hover': { backgroundColor: '#e0e7ff' },
              textTransform: 'none',
            }}
              onClick={() => navigate('/login')}
          >
            Learn More
          </Button>
        </motion.div>
      </Box>


      <Container maxWidth="lg">
        <Box sx={{ mt: 12 }}>
  <Typography
    variant="h4"
    fontWeight="700"
    color="primary"
    textAlign="center"
    gutterBottom
    sx={{ fontFamily: "'Poppins', sans-serif" }}
  >
    Our Core Values
  </Typography>
  <Grid container spacing={6} sx={{ mt: 4 }} justifyContent="center">
    {[
      {
        icon: <Lightbulb sx={{ fontSize: 50, color: '#4a90e2' }} />,
        title: 'Innovation',
        description:
          'We harness creativity and modern technologies to deliver a dynamic and engaging online learning experience.',
      },
      {
        icon: <Public sx={{ fontSize: 50, color: '#9013fe' }} />,
        title: 'Global Community',
        description:
          'We connect learners and instructors from around the world with openness and respect.',
      },
      {
        icon: <Group sx={{ fontSize: 50, color: '#f50057' }} />,
        title: 'Inclusivity',
        description:
          'We welcome learners from all backgrounds and skill levels to learn, share, and grow together.',
      },
    ].map((item, i) => (
      <Grid item xs={12} md={4} key={i}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: i * 0.3 }}
          viewport={{ once: true }}
        >
          <Paper
            elevation={3}
            sx={{
              p: 5,
              borderRadius: 4,
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              bgcolor: 'white',
              boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: '0 12px 30px rgba(0,0,0,0.15)',
              },
            }}
          >
            <Box mb={3}>{item.icon}</Box>
            <Typography
              variant="h6"
              fontWeight="700"
              gutterBottom
              sx={{ fontFamily: "'Poppins', sans-serif" }}
            >
              {item.title}
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ fontFamily: "'Inter', sans-serif" }}
            >
              {item.description}
            </Typography>
          </Paper>
        </motion.div>
      </Grid>
    ))}
  </Grid>
</Box>


        {/* Meet The Team */}
        <Box sx={{ mt: 14 }}>
          <Typography
            variant="h4"
            fontWeight="700"
            color="primary"
            textAlign="center"
            gutterBottom
            sx={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Meet the Team
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            textAlign="center"
            sx={{ maxWidth: 600, mx: 'auto', mb: 6, fontFamily: "'Inter', sans-serif" }}
          >
            A passionate and multidisciplinary team dedicated to providing you with the best online education experience.
          </Typography>

          <Grid container spacing={6} justifyContent="center">
            {teamMembers.map((member, i) => (
              <Grid item xs={12} sm={6} md={3} key={i}>
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.7, delay: i * 0.25 }}
                  viewport={{ once: true }}
                >
                  <Paper
                    elevation={4}
                    sx={{
                      p: 4,
                      borderRadius: 5,
                      textAlign: 'center',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
                      transition:
                        'transform 0.3s ease, box-shadow 0.3s ease',
                      '&:hover': {
                        transform: 'scale(1.1)',
                        boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
                      },
                    }}
                  >
                    <Avatar
                      sx={{
                        bgcolor: '#9013fe',
                        width: 80,
                        height: 80,
                        fontSize: 36,
                        mb: 3,
                        fontWeight: '700',
                      }}
                    >
                      {member.avatar}
                    </Avatar>
                    <Typography
                      variant="h6"
                      fontWeight="700"
                      sx={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      {member.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ fontFamily: "'Inter', sans-serif", mt: 1 }}
                    >
                      {member.role}
                    </Typography>
                  </Paper>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Contact Us */}
<Box sx={{ mt: 14, mb: 8, textAlign: 'center' }}>
  <Divider sx={{ mb: 4, maxWidth: 100, mx: 'auto', borderColor: '#9013fe' }} />
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, ease: 'easeOut' }}
    viewport={{ once: true }}
  >
    <Typography
      variant="h4"
      fontWeight="700"
      color="primary"
      gutterBottom
      sx={{ fontFamily: "'Poppins', sans-serif" }}
    >
      Get in Touch
    </Typography>
    <Typography
      variant="body1"
      color="text.secondary"
      sx={{ maxWidth: 500, mx: 'auto', mb: 4, fontFamily: "'Inter', sans-serif" }}
    >
      We’d love to hear from you. Whether you have a question, feedback, or an idea, feel free to reach out and help us improve our platform.
    </Typography>

    <Link to="/contact" style={{ textDecoration: 'none' }}>
      <Button
        variant="outlined"
        startIcon={<ContactMail />}
        sx={{
          textTransform: 'none',
          borderColor: '#9013fe',
          color: '#9013fe',
          fontWeight: 600,
          px: 5,
          py: 1.5,
          borderRadius: 3,
          '&:hover': {
            borderColor: '#6a1b9a',
            backgroundColor: '#f3eaff',
          },
        }}
      >
        Contact Us
      </Button>
      </Link>
  </motion.div>
</Box>
</Container>
    </Box>
  );
}

